import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=bb75e68e&scoped=true&"
import script from "./accountDetail.vue?vue&type=script&lang=js&"
export * from "./accountDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=bb75e68e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb75e68e",
  null
  
)

export default component.exports